import { FC } from 'react';
import { useUnit } from 'effector-react';
import { Formik } from 'formik';
import { Wrapper } from '@ui/index';
import { $ticket, ticketSubmitted } from '../../models';
import { TicketForm } from '../ticket-form';
import { useStyles } from './styles';
import { validationSchema } from './validation';

interface Props {
  external?: boolean;
  showOnlyInvoces?: boolean;
}

export const Ticket: FC<Props> = ({ external = false }) => {
  const ticket = useUnit($ticket);
  const classes = useStyles({ external });

  const ticketJson = JSON.stringify(ticket);

  const isNew = !ticket.id;

  return (
    <Wrapper className={classes.wrapper}>
      <Formik
        key={ticketJson}
        initialValues={ticket}
        validationSchema={validationSchema}
        onSubmit={ticketSubmitted}
        enableReinitialize
        render={({ values, setFieldValue, resetForm, errors }) => (
          <TicketForm
            values={values}
            setFieldValue={setFieldValue}
            resetForm={resetForm}
            errors={errors}
            external={external}
            isNew={isNew}
          />
        )}
      />
    </Wrapper>
  );
};
